import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import DisplayForm, { displayFormConfig } from './DisplayForm';
import { modifyDisplay } from '../../api';
import { ipConverter } from '@its/util';
import { setSelectedDisplay } from '../../redux/display/actions';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { merge } from '@its/util';
import {
  setVisibility,
} from '@its/components/lib/Container components/LoadingContainer/actions';
import {
  setSuccessSnackBar,
  setErrorSnackBar,
} from '@its/components/lib/Container components/SnackBarContainer/actions';
import {
  setAppBar,
} from '@its/components/lib/Container components/DrawerMenuContainer/actions';
import {
  FrameTimerText,
  FrameOrderText,
  SetCurrentPage,
  Ipv4LAN1,
  Ipv4LAN2,
  ipv4LAN1NotReachable,
  ipv4LAN2NotReachable,
} from '../../i18n/intl';
import {
  isAllowed,
  developer,
  admin,
  config,
  standard,
} from '@its/components/lib/Container components/UserContainer/roles';

const refreshPage = (dispatch) => {
  // TODO : trovare un'altra soluzione per distruggere e ricreare il form
  const path = window.location.pathname;
  dispatch(replace('/refresh'));
  dispatch(replace(path));
};

export default class extends React.Component {

  static propTypes = {
    name: React.PropTypes.string.isRequired,
    getWysiwyg: React.PropTypes.func.isRequired,
    onSubmit: React.PropTypes.string.isRequired,
    appBar: React.PropTypes.object,
    selectedObject: React.PropTypes.object,
    expandDisplayForm: React.PropTypes.bool,
    hideCancel: React.PropTypes.bool,
    setAppBar: React.PropTypes.bool,
  }

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
  }

  static defaultProps = {
    store: React.PropTypes.object.isRequired,
    expandDisplayForm: true,
    hideCancel: false,
    setAppBar: true,
  }

  constructor(props, context) {
    super(props, context);
    if (props.appBar && props.setAppBar) {
      this.context.store.dispatch(setAppBar(props.appBar));
    }

    this.getWysiwygConfig = ::this.getWysiwygConfig;
    this.getWysiwygGroups = ::this.getWysiwygGroups;

    const currentState = this.context.store.getState();
    const formatValues = (values, wisywigValues, wisywigSettings) => {
      const result = Object.assign({}, values, wisywigValues, wisywigSettings);
      result.iPv4_LAN1 = ipConverter.toIp(result.iPv4_LAN1);
      result.iPv4_LAN2 = ipConverter.toIp(result.iPv4_LAN2);
      return result;
    };

    let displayMaps;
    let displayTemplateMaps;
    let currentDisplay = props.selectedObject || Object.assign({}, currentState.app.displays.detail);
    if (props.selectedObject) {
      displayMaps = props.selectedObject.displayMaps;
      const template = this.getSelectedTemplate(
        currentState.app.templates.items,
        props.selectedObject
      );
      displayTemplateMaps = template.displayTemplateMaps;
    } else {
      displayMaps = [...currentState.app.displays.detail.displayMaps];
      displayTemplateMaps = [...currentState.app.templates.detail.displayTemplateMaps];
    }

    const wysiwyg = props.getWysiwyg(
      Object.assign({}, displayMaps),
      displayTemplateMaps,
      currentState.app.plugins.list
    );

    let wysiwygSettings = {};
    if (Array.isArray(wysiwyg.fields)) {
      wysiwygSettings = this.getWysiwygGroups(wysiwyg.fields, currentDisplay);
    }

    if (!props.expandDisplayForm && wysiwygSettings.config) {
      wysiwygSettings.config.groups = [wysiwygSettings.config.groups[0]];
    }

    const formConfig = wysiwygSettings.config || this.getWysiwygConfig(wysiwyg.fields);

    const mapStateToProps = ((display) =>
      (state) => (
        {
          name: props.name || `modifyDisplay${display.id}`,
          request: modifyDisplay(display.id),
          initialValues: formatValues(
            display,
            wysiwyg.initialValues,
            wysiwygSettings.initialValues || {}
          ),
          onSubmit: props.onSubmit.bind(null, display, displayTemplateMaps),
          onSuccess: (result, dispatch) => {
            dispatch(setSelectedDisplay(result.body));
            refreshPage(dispatch);
          },
          hideCancel: props.hideCancel,
          submitTop: true,
          submitDisabled: !isAllowed(
            [
              admin,
              developer,
              config,
              standard,
            ], state.user.roles
          ),
          config: formConfig,
        }
    ))(currentDisplay);

    const ModificationForm = connect(
      mapStateToProps
    )(DisplayForm);

    this.component = <ModificationForm />;
  }

  getSelectedTemplate(templates, display) {
    let i = 0;
    let template;
    let found = false;
    while (templates[i] && (i < templates.length || !found)) {
      if (templates[i].id === display.templateId) {
        template = templates[i];
        found = true;
      }
      i++;
    }
    return template;
  }

  getWysiwygConfig(fields) {
    const result = Object.assign({}, displayFormConfig);
    result.groups = [...displayFormConfig.groups];
    result.groups.unshift({
      key: 'wysiwyg',
      parentStyle: {
        textAlign: 'center',
      },
      style: {
        backgroundColor: '#333333',
        padding: 10,
        display: 'inline-block',
      },
      noSpace: true,
      fields,
    });
    return result;
  }

  getWysiwygGroups(fieldsArrays, currentDisplay) {
    const state = this.context.store.getState();
    const { dispatch } = this.context.store;
    const timerList = state.app.timers.list;
    const result = {
      config: Object.assign({}, displayFormConfig),
      initialValues: {},
    };
    result.config.groups[1].fields.iPv4_LAN1.floatingLabelText = currentDisplay.offLineOn_LAN1 ? ipv4LAN1NotReachable : Ipv4LAN1;
    result.config.groups[1].fields.iPv4_LAN2.floatingLabelText = currentDisplay.offLineOn_LAN2 ? ipv4LAN2NotReachable : Ipv4LAN2;
    const wysiwygGroups = [];

    result.config.groups = [...displayFormConfig.groups];

    const setFramePosition = (id, newFrameId) => {
      if (id != newFrameId) {
        dispatch(setVisibility(true));
        const display = merge(currentDisplay, {});
        const shift = newFrameId - id;
        if (id < newFrameId) {
          const length = newFrameId - id + 1;
          display.displayMaps
               .filter((x) => Number(x.frame) >= id && Number(x.frame) <= newFrameId)
               .forEach((x) => {
                 let newId = Number(x.frame) + shift;
                 if (newId > newFrameId) {
                   newId -= length;
                 }
                 x.frame = newId;
               });
        } else if (id > newFrameId) {
          const length = id - newFrameId + 1;
          display.displayMaps
               .filter((x) => Number(x.frame) >= newFrameId && Number(x.frame) <= id)
               .forEach((x) => {
                 let newId = Number(x.frame) + shift;
                 if (newId < newFrameId) {
                   newId += length;
                 }
                 x.frame = newId;
               });
        }
        
        display.forceUpdate = true;
        modifyDisplay(currentDisplay.id)(display).then((data) => {
          dispatch(setSelectedDisplay(data.body));
          dispatch(setSuccessSnackBar());
          refreshPage(dispatch);
        }).catch(() => {
          dispatch(setErrorSnackBar());
        }).finally(() => {
          dispatch(setVisibility(false));
        });
      }
    };
    for (let i = 1; i < fieldsArrays.length + 1; i++) {
      if (!fieldsArrays[i]) {
        continue;
      }
      const wysiwygSettings = {
        key: `wysiwyg_settings${i}`,
        parentStyle: {
          textAlign: 'center',
        },
        fields: {},
      };
      wysiwygSettings.fields[`_${i}_iterationId`] = {
        type: 'select',
        floatingLabelText: FrameTimerText,
        items: timerList,
        style: {
          textAlign: 'left',
        },
        autoWidth: true,
        validators: {
          required: true,
        },
      };
      wysiwygSettings.fields[`_${i}_setFramePosition`] = {
        type: 'select',
        floatingLabelText: FrameOrderText,
        items: Array.apply(null, Array(currentDisplay.displayFramesIteration.length)).map((item, index) => ({
          primaryText: String(index + 1),
          value: index + 1,
          onTouchTap: () => {
            setFramePosition(i, index + 1);
          },
        })),
        style: {
          textAlign: 'left',
        },
        autoWidth: true,
        validators: {
          required: true,
        },
      };
      const setCurrentFrame = (id) => () => {
        dispatch(setVisibility(true));
        const display = merge(currentDisplay, { currentFrame: id });
        display.forceUpdate = true;
        modifyDisplay(currentDisplay.id)(display).then(() => {
          dispatch(setSuccessSnackBar());
        }).catch(() => {
          dispatch(setErrorSnackBar());
        }).finally(() => {
          dispatch(setVisibility(false));
        });
      };
      wysiwygSettings.fields[`_${i}_setFrame`] = {
        component: RaisedButton,
        label: SetCurrentPage,
        onMouseUp: setCurrentFrame(i),
        onTouchEnd: setCurrentFrame(i),
        secondary: true,
        newLine: true,
        disabled: Number(currentDisplay.currentFrame) === i,
      };
      for (const displayFrameIteration of currentDisplay.displayFramesIteration) {
        if (Number(displayFrameIteration.frame) === i) {
          result.initialValues[`_${i}_setFramePosition`] = i;
          result.initialValues[`_${i}_iterationId`] = displayFrameIteration.iterationId;
          wysiwygSettings.fields[`_${i}_setFrame`].disabled = (
            currentDisplay.currentFrame === displayFrameIteration.frame
          );
        }
      }
      wysiwygGroups.push([
        {
          key: `wysiwyg${i}`,
          parentClass: 'wysiwyg-container',
          className: 'wysiwyg',
          style: {
            padding: 10,
          },
          noSpace: true,
          fields: fieldsArrays[i].fields,
        },
        {
          ...wysiwygSettings,
        },
      ]);
    }
    result.config.groups.unshift(wysiwygGroups);
    return result;
  }

  render() {
    return this.component;
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/WysiwygForm.js
 **/